<template>
    <div class="deptPowerWarper">
        <div>{{powerQuery.payeeName}} - {{powerQuery.departName}} 收款部门权限组开通</div>
        <div class="smallT">已开通权限组：</div>
        <div class="powerTable">
            <avue-crud  :data="data" ref="crud" :option="option" :table-loading="loading" @row-del="rowDel">
                <template slot-scope="{type,size,row}" slot="menu">
                    <el-button  :type="type" icon="el-icon-view" size="small"
                    @click="powerCheck(row)">查看权限组人员</el-button>
                </template>
            </avue-crud>
        </div>
    </div>
</template>
<script>
import request from '@/router/axios';
export default {
    name: 'deptPower',
    data(){
        return {
            form:'',
            dic:[],
            data: [],
            loading: false,
            powerQuery:{},
            option:{
            addBtn: false,
            page:false,
            align:'center',
            menuAlign:'center',
            viewBtn: false,
            delBtn: true,
            classId: this.$route.query.classId,
            delBtnText:'删除权限组',
            // viewBtnText:'查看权限组人员',
            editBtn: false,
            column:[
                {
                    label:'集团／公司',
                    prop:'parentName'
                },
                {
                    label:'部门',
                    prop:'deptName'
                }
            ]
            }
        }
    },
    mounted(){
        this.powerQuery = JSON.parse(sessionStorage.getItem("powerQuery"));
        // console.log(this.powerQuery)
        this.onLoad(this.powerQuery.classId)
    },
    methods: {
        onLoad(departId) {
            this.data = []
            this.loading = true;
            request({
                url: '/api/zt-pay/department/getDept',
                method: 'get',
                port: '8016',
                params:{ id: departId}
            }).then((res)=>{
                // console.log(res.data.data)
                let resp = res.data.data
                this.data.push(resp)
                this.loading = false;
            })
        },

        // 请求添加/编辑/删除 接口
        postPower(id, classId){
            request({
                url: 'api/zt-pay/department/updateDepartment',
                method: 'post',
                data:{ id: id, classId: classId}
            }).then((res)=>{
                // if(res.data.success){
                //     this.$message({
                //         type: "success",
                //         message: "操作成功!"
                //     });
                // }
            })
        },

        // 点击删除权限组按钮
        rowDel(row, index, done) {
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                // return remove(row.id);
                let id = this.powerQuery.departId !== '' ? this.powerQuery.departId : ''
                this.postPower(id, '')
            })
            .then(() => {
                this.$message({
                type: "success",
                message: "操作成功!"
                });
                // this.powerQuery.classId = ''
                // let query = JSON.stringify(this.powerQuery)
                // sessionStorage.setItem("powerQuery", query);

                this.timer = setTimeout(()=>{
                    this.$router.push({ path: '/pay/addPower'})
                },1500)
                done(row);
            });
        },
        powerCheck(row){
            console.log(row)
            let deptId = this.powerQuery.departId !== '' ? this.powerQuery.departId : ''
            this.$router.push({ path: '/system/user', query: { classId: row.id, deptId: deptId }})
        }
    },
    destroyed(){
        clearTimeout(this.timer)
    },
    watch:{
    //   form:{
    //      handler() {
    //       setTimeout(()=>{
    //         console.log(this.$refs.tree)
    //         this.form33=this.$refs.tree.getHalfList();
    //         console.log(this.form33)
    //       },0)
    //     },
    //     immediate: true,
    //   }
    }
}
</script>
<style scoped>
    .deptPowerWarper{ background: #ffffff; padding: 20px;}
    .avue-input-tree{
        width: 60%;
    }
    .powerAdd{
        margin-bottom: 15px;
        margin-top: 15px;
    }
    .powerTable{
        margin-top: 20px;
    }
    .addBtn{ margin-left: 20px; min-width: 60px; padding: 12px 30px;}
    .smallT{ font-size: 14px; color: #666; margin-top: 10px;}
</style>
